import RecommendationEngineManagement from '@/features/settings/components/recommendation-engine-management'

export function SettingsRecommendationsPage() {
    return <RecommendationEngineManagement />
}
